export default "__VITE_ASSET__15a8b68f__"